import { CheckNotes, InspectionCase } from '../../inspection-cases';
import {
  InspectionPercentageCase,
  InspectionPercentageCaseDto
} from '../../inspection-cases/inspection-percentage-case.dto';

export class FoamFloodingSystemsDto extends InspectionCase {
  pressureReducersAsDesigned?: InspectionCase;
  systemActivation?: InspectionCase;
  uniformFlow?: InspectionCase;
  reducerPressureAsDesigned?: InspectionCase;
  dispensingDevicesWorks?: InspectionCase;
  FoamSampling?: InspectionCase;
  waterCheck?: InspectionCase;
  concentrateFoamfromStorageVessels?: InspectionCase;
  foamConcentrationResults?: InspectionPercentageCaseDto;
}

export class FoamFloodingSystems extends FoamFloodingSystemsDto {
  constructor(data: FoamFloodingSystemsDto = { title: 'מערכות הצפה בקצף' }) {
    super(data);
    this.pressureReducersAsDesigned = new InspectionCase({
      ...data.pressureReducersAsDesigned,
      title: `בהתקנת מקטיני לחץ לפני ראש המערכת ציין את הלחץ , האם תואם לתכנון`
    });
    this.systemActivation = new InspectionCase({
      ...data.systemActivation,
      title: `בדוק הפעלת המערכת בכל האפשרויות להפעלתו, לדוגמא (לא מחייב):ע"י גלאי / פיילוט (בפיילוט ברז הבדיקה בסוף הקו), לחצן חשמלי, ברז פתיחה מהיר, הפעלה מרחוק: מכני או חשמלי`
    });
    this.uniformFlow = new InspectionCase({
      ...data.uniformFlow,
      title: `הפעל את המערכת באופן ידני או אוטומטי עד לקבלת ספיקה אחידה. (ההפעלה תהיה ע"י המתקין)`
    });
    this.reducerPressureAsDesigned = new InspectionCase({
      ...data.reducerPressureAsDesigned,
      title: `הלחץ במורד מקטין הלחץ (באם נדרש) מכוון ללחץ המתוכנן`
    });
    this.dispensingDevicesWorks = new InspectionCase({
      ...data.dispensingDevicesWorks,
      title: `וודא שכל התקני הפיזור עובדים באופן מלא ללא הפרעות בפעולה`
    });
    this.FoamSampling = new InspectionCase({
      ...data.FoamSampling,
      title: `בקבלת קצף לצורך איסוף דגימה , אסוף קצף דגימה מתמיסת הפרימיקס מברז בדיקה ייעודי רק לאחר הזרמה של דקה. יש לאסוף כמות של 300 סמ"ק לפחות`
    });
    this.waterCheck = new InspectionCase({
      ...data.waterCheck,
      title: `יש לאסוף כמות מים של לפחות ליטר וחצי בכלי מתאים. את המים יש לקחת מקו הכיבוי לפני  מרכז הקצף`
    });
    this.concentrateFoamfromStorageVessels = new InspectionCase({
      ...data.concentrateFoamfromStorageVessels,
      title: `יש לאסוף בכלי כמות של לפחות 10 סמ"ק של תרכיז הקצף מכלי האגירה בשטח`
    });
    this.foamConcentrationResults = new InspectionPercentageCase({
      ...data.foamConcentrationResults,
      title: `יש לבצע בדיקת ריכוזים בהתאם לנוהל מס':10-07-00 - האם התקבלו ריכוזי קצף בהתאם לדרישות התקן ודרישות התכנון - ציין את ריכוז הקצף שהתקבל`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.pressureReducersAsDesigned.isApplicable ||
        this.pressureReducersAsDesigned.isPassed) &&
        (!this.systemActivation.isApplicable ||
          this.systemActivation.isPassed) &&
        (!this.uniformFlow.isApplicable || this.uniformFlow.isPassed) &&
        (!this.reducerPressureAsDesigned.isApplicable ||
          this.reducerPressureAsDesigned.isPassed) &&
        (!this.dispensingDevicesWorks.isApplicable ||
          this.dispensingDevicesWorks.isPassed) &&
        (!this.FoamSampling.isApplicable || this.FoamSampling.isPassed) &&
        (!this.waterCheck.isApplicable || this.waterCheck.isPassed) &&
        (!this.concentrateFoamfromStorageVessels.isApplicable ||
          this.concentrateFoamfromStorageVessels.isPassed) &&
        (!this.foamConcentrationResults.isApplicable ||
          this.foamConcentrationResults.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.pressureReducersAsDesigned.getNotes(),
      ...this.systemActivation.getNotes(),
      ...this.uniformFlow.getNotes(),
      ...this.reducerPressureAsDesigned.getNotes(),
      ...this.dispensingDevicesWorks.getNotes(),
      ...this.FoamSampling.getNotes(),
      ...this.waterCheck.getNotes(),
      ...this.concentrateFoamfromStorageVessels.getNotes(),
      ...this.foamConcentrationResults.getNotes()
    ];
  }
}
